import { CONFIG } from './config'

export const VALIDGUESSES = [
  'adaawḵ',
  'adixs',
  'algyax̱',
  'algyax̱',
  'alisxw',
  'amalkw',
  'anist',
  'anjam',
  'anjoḵ',
  "an'on",
  'ayukws',
  "ay'aa'y",
  'aajax̱xw',
  'aapxin',
  "aat'ixs",
  'balgi',
  'balim',
  'bilan',
  'damḵxw',
  "da'mas",
  "dee'ntxw",
  "didi'y",
  "di'mhlxw",
  'dipx̱s',
  'dulpxw',
  'duxwsxw',
  "ee'esxw",
  'gidax̱',
  "gik'uuhl",
  'gilan',
  "gilaa'l",
  'ginees',
  "gi'nam",
  "gitl'",
  "gits'ooḵ",
  'g̱alan',
  "g̱alaaḵ'",
  "g̱anaa'w",
  'g̱aniis',
  'g̱aniis',
  'g̱antxw',
  "g̱as'uu",
  'g̱ehlx̱xw',
  'g̱enin',
  'g̱esx̱xw',
  'g̱olix',
  "g̱oo'os",
  "gwalḵ'a",
  'gwanks',
  'gwaasxwt',
  "gwidats'",
  'gwooyim',
  'gyamks',
  'gyax̱gu',
  'gyuksxw',
  'gyuwil',
  'habax̱',
  'hadix',
  'hagul',
  'hagun',
  'hakhlxw',
  'halakw',
  'hamom',
  "ha'mats",
  "ha'mooḵ",
  "hanaḵ'",
  'hanix',
  'hasaḵ',
  'hasba',
  'haseex',
  "hat'a'l",
  "hats'al",
  'hawil',
  'hayats',
  'haawaḵ',
  'hidin',
  'hilin',
  'hiihluxw',
  'hogix̱',
  'hoobix',
  "hu'max̱",
  'hlag̱oḵ',
  'hlantxw',
  "hlat'ax̱",
  'hlgilkw',
  'hlguya',
  "hliba'l",
  'hlisin',
  'hliyun',
  "hlut'ax̱",
  "ihlee'e",
  'ixsda',
  'japaan',
  'jayaas',
  'jayeehl',
  'jilks',
  "k'utk'u",
  "ḵ'alaa'n",
  "ḵ'eeg̱an",
  "ḵ'oox̱st",
  "kw'aat'ax̱",
  "kw'oodin",
  'laltxw',
  'laalax̱',
  "ligi'l",
  'litsx̱xw',
  'log̱ox̱',
  "lo'op",
  "lukw'il",
  "luulaḵ'",
  'mamst',
  'mandi',
  "ma'us",
  'maadim',
  'maaxwsxw',
  'midin',
  'milit',
  'miyup',
  "mi'yan",
  "mi'in",
  'miiluxw',
  'momst',
  "mo'on",
  "'masim",
  "'miyahl",
  "'mo'oxw",
  'naksxw',
  'naag̱ets',
  "naasik'",
  "no'ohl",
  'noosiḵ',
  'nuuhlx̱xw',
  "'niḵ'an",
  'saksxw',
  "sak'in",
  "saḵ'ap",
  'seegit',
  'seeg̱al',
  'seeg̱al',
  'seeg̱al',
  "see'lax̱",
  'sg̱ans',
  'sg̱enx',
  'sg̱olts',
  'sitxwt',
  "siip'in",
  "sḵ'eex̱xw",
  "skw'atxw",
  "sma'wn",
  'sog̱om',
  "tl'ook'",
  "t'asxu",
  "t'ilix",
  "t'uuts'xwa",
  "ts'ahlx̱xw",
  "ts'amtx",
  "ts'itxs",
  "ts'iipxwt",
  "ts'o'ot",
  "ts'u'win",
  'walix',
  'wantxw',
  "wat'uxw",
  'wijix',
  'wilaax',
  'wilḵt',
  'wineex',
  'wisax',
  'wisin',
  "wo'os",
  "'wahlin",
  "'widin",
  'xsg̱ooḵ',
  'xsihlxw',
  'x̱biist',
  "x̱pts'axw",
  'x̱sgyaak',
  'x̱sinḵ',
  "x̱ts'aḵxw",
  'yag̱ay',
  'yoog̱an',
  'yuxwsa',
  'adixs',
  'anaax',
  'anist',
  'anjam',
  'ankws',
  "an'on",
  'awsxw',
  'ax̱xw',
  'balgi',
  'balim',
  'baasx',
  'bilan',
  'bilaa',
  'bisxw',
  'bitxw',
  "boḵ'",
  'dalḵ',
  'daala',
  'dilx̱',
  "doḵ'",
  'duula',
  "duu'u",
  'gibuu',
  'gilan',
  "gitl'",
  'gitxw',
  'giihl',
  'giikw',
  'guxws',
  'g̱ala',
  'g̱ats',
  'g̱ax̱',
  'g̱ayt',
  'g̱aap',
  "g̱e'n",
  'g̱oot',
  'g̱oot',
  'gwila',
  'gwilt',
  'gyals',
  'gyamk',
  'gyaxw',
  "gya'a",
  "gyop'",
  'gyuks',
  'hadix',
  'hagul',
  'hagun',
  'hamom',
  'hanix',
  'hasba',
  "hats'",
  'hawil',
  'haykw',
  'hetxw',
  'hidin',
  'hilin',
  "hi'la",
  'hupx̱',
  'huxws',
  'hlalp',
  'hlaxw',
  "hlit'",
  'ixsda',
  'japxw',
  'jilks',
  'juxwt',
  "k'eex",
  "ḵ'ap",
  "ḵ'ap",
  "ḵ'ay",
  'laḵs',
  'lax̱s',
  'laax̱',
  'laaxw',
  "loḵ'",
  "lo'op",
  'luxwt',
  'mahla',
  'mahlt',
  'maḵt',
  'maḵt',
  'mamst',
  'mandi',
  'masxw',
  "ma'us",
  'maaks',
  "maa'y",
  'meeḵ',
  'meex̱',
  'midin',
  'mihla',
  'milit',
  'mitxw',
  'miyup',
  "mi'in",
  'momst',
  "mo'on",
  'moohl',
  'mooji',
  "'malu",
  "'mats",
  "'mukw",
  "naḵ'",
  'neeḵ',
  'nimḵ',
  'nisx̱',
  "nuts'",
  "'nakw",
  "'nax̱",
  "sak't",
  "saḵ'",
  'saxwt',
  'sdax̱',
  'sduup',
  'sgyan',
  'silkw',
  'sipxw',
  'sugwa',
  "s'yun",
  "tḵ'a",
  'tx̱as',
  'tx̱aa',
  'tx̱ox',
  "t'aks",
  "t'ax̱",
  "t'axw",
  "t'aap",
  "t'ixw",
  "t'oḵ",
  "t'uxs",
  "ts'ak",
  "ts'al",
  "ts'ap",
  "ts'ee",
  "ts'im",
  "ts'in",
  'walix',
  'wijix',
  'wisax',
  'wisin',
  "woḵ'",
  "wo'os",
  "woot'",
  "'ween",
  'xsax̱',
  'xsaxw',
  'xsiip',
  "x̱a'a",
  'x̱bil',
  'x̱dii',
  'x̱san',
  'x̱sit',
  'xwdax',
  'xwdaa',
  'xwsit',
  'yankw',
  "'yaḵ",
  "'yans",
  "'yimk",
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
